
import { evaluate, ValueOrGetter } from "@tylertech/lgd-reactive-forms";

import { Action, Command } from "../interfaces";

import { ForgeButtonType } from "./forgeButtonType";

export interface IconCommandOptions
{
    // REVIEW - do we ever need icon to be dynamic?
    readonly icon?: string;
    readonly color?: ValueOrGetter<string>;
    readonly label?: ValueOrGetter<string>;
    readonly action: Action;
    readonly getVisible?: ValueOrGetter<boolean>;
    readonly getEnabled?: ValueOrGetter<boolean>;
    readonly tooltip?: ValueOrGetter<string>;
    readonly disabledTooltip?: ValueOrGetter<string>;
    readonly tooltipDirection?: string;
    readonly type?: ForgeButtonType;
}

export class IconCommand implements Command
{
    private readonly _label: ValueOrGetter<string>;
    private readonly _color: ValueOrGetter<string>;
    private readonly _tooltip: ValueOrGetter<string>;
    private readonly getEnabled: ValueOrGetter<boolean>;
    private readonly getVisible: ValueOrGetter<boolean>;

    readonly icon: string;
    readonly _disabledTooltip: ValueOrGetter<string>;
    readonly action: Action;
    readonly tooltipDirection?: string;
    readonly type?: ForgeButtonType;
    classString: string;

    constructor(options: IconCommandOptions)
    {
        this.icon = options.icon;
        this._label = options.label;
        this._color = options.color;
        this._tooltip = options.tooltip;
        this._disabledTooltip = options.disabledTooltip;
        this.tooltipDirection = options.tooltipDirection;
        this.action = options.action;
        this.getEnabled = options.getEnabled;
        this.getVisible = options.getVisible;
        this.type = options.type;
    }

    get label(): string
    {
        return this._label
            ? evaluate(this._label)
            : undefined;
    }

    get tooltip(): string
    {
        return this._tooltip
            ? evaluate(this._tooltip)
            : undefined;
    }

    get disabledTooltip(): string
    {
        return this._disabledTooltip
            ? evaluate(this._disabledTooltip)
            : undefined;
    }

    get color(): string
    {
        return this._color
            ? evaluate(this._color)
            : undefined;
    }

    get isVisible(): boolean
    {
        return this.getVisible
            ? evaluate(this.getVisible)
            : true;
    }

    get isEnabled(): boolean
    {
        return this.getEnabled
            ? evaluate(this.getEnabled)
            : true;
    }

}
